import { routeMappings } from '../../constants';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import BasicTaskListPage from '../../basicTaskList/components/BasicTaskListPage';
import withTaskFlow from '../../taskList/components/WithTaskFlow';
import { RouteParams } from '../../base/components/Routes';
import { StageCompletionPage } from '../../staticPages/components/StageCompletionPage';
import AccessibilityInformationPage from './../../staticPages/components/AccessibilityInformationPage';
import BasicSurveyPage from '../../staticPages/components/BasicSurveyPage';

const basicTaskListRoutes: RouteParams[] = [
  {
    path: routeMappings['BASICTASKLIST_END'],
    exact: true,
    component: withBasicDetails(withTaskFlow(StageCompletionPage)),
  },
  {
    path: `${routeMappings['BASICTASKLIST']}/:id`,
    exact: true,
    component: withBasicDetails(BasicTaskListPage),
  },
  {
    path: `${routeMappings['TASK_COMPLETION']}`,
    exact: true,
    component: withBasicDetails(StageCompletionPage),
  },
  {
    path: `${routeMappings['FORM_COMPLETION']}`,
    exact: true,
    component: withBasicDetails(StageCompletionPage),
  },
  {
    path: `${routeMappings['ACCESSIBILITY_INFO']}`,
    exact: true,
    component: withBasicDetails(AccessibilityInformationPage),
  },
  {
    path: `${routeMappings['BASIC_SURVEY_PAGE']}`,
    exact: true,
    component: withBasicDetails(BasicSurveyPage),
  },
  {
    path: `${routeMappings['BASICTASKLIST_HURDLE_FAIL']}`,
    exact: true,
    component: withBasicDetails(withTaskFlow(StageCompletionPage)),
  },
  {
    path: `${routeMappings['MANUAL_HURDLE']}`,
    exact: true,
    component: withBasicDetails(withTaskFlow(StageCompletionPage)),
  },
  {
    path: `${routeMappings['TASK']}/:id${routeMappings['EXPASSES']}/:itemId${routeMappings['SCORE_EVALUATION']}`,
    exact: true,
    component: withBasicDetails(withTaskFlow(StageCompletionPage)),
  },
];

export default basicTaskListRoutes;
